<div *ngIf="selectedDocContent as sdcontent">
  <p-table #cTable
           [value]="sdcontent"
           dataKey="DOCITEMID"
           selectionMode="single"
           [(selection)]="selectedContentRow"
           [filterDelay]="300"
           rowExpandMode="single"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
           [rowHover]="true"
           [resizableColumns]="true"
           [loading]="loading">

    <ng-template pTemplate="header">
      <tr [ngSwitch]="selectedDocType">
        <th style="width: 3rem"></th>
        <th pSortableColumn="PRODCODE" pResizableColumn style="width: 25% !important"> Товар <p-sortIcon field="PRODCODE"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMPRODNAME" pResizableColumn style="width: 35% !important">Описание <p-sortIcon field="DOCITEMPRODNAME"></p-sortIcon></th>
        <th *ngSwitchCase="1" pSortableColumn="DOCITEMSTOCK" pResizableColumn style="width: 6rem !important">На складе <p-sortIcon field="selectedDocContent.prodInfo.PRODSTOCK"></p-sortIcon></th>
        <th *ngSwitchCase="2" pSortableColumn="DOCITEMSTOCK" pResizableColumn style="width: 6rem !important">На складе <p-sortIcon field="selectedDocContent.prodInfo.PRODSTOCK"></p-sortIcon></th>
        <th *ngSwitchCase="4" pSortableColumn="DOCITEMSTOCK" pResizableColumn style="width: 6rem !important">На складе <p-sortIcon field="selectedDocContent.prodInfo.PRODSTOCK"></p-sortIcon></th>
        <th *ngSwitchCase="5" pSortableColumn="DOCITEMSTOCK" pResizableColumn style="width: 6rem !important">На складе <p-sortIcon field="selectedDocContent.prodInfo.PRODSTOCK"></p-sortIcon></th>
        <th *ngSwitchCase="12" pSortableColumn="DOCITEMSTOCK" pResizableColumn style="width: 6rem !important">На складе <p-sortIcon field="selectedDocContent.prodInfo.PRODSTOCK"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMQTY" pResizableColumn style="width: 8rem !important">Количество <p-sortIcon field="DOCITEMQTY"></p-sortIcon></th>
        <th *ngSwitchCase="1" pSortableColumn="DOCITEMSHIPPED" pResizableColumn style="width: 6rem !important">Отгружено <p-sortIcon field="DOCITEMSHIPPED"></p-sortIcon></th>
        <th *ngSwitchCase="1" pSortableColumn="DOCITEMPRICE" pResizableColumn style="width: 8rem !important">Цена <p-sortIcon field="DOCITEMPRICE"></p-sortIcon></th>
        <th *ngSwitchCase="1" pSortableColumn="DOCITEMSUM" pResizableColumn style="width: 10rem !important">Сумма <p-sortIcon field="DOCITEMSUM"></p-sortIcon></th>
        <th *ngSwitchCase="2" pSortableColumn="DOCITEMPRICE" pResizableColumn style="width: 8rem !important">Цена <p-sortIcon field="DOCITEMPRICE"></p-sortIcon></th>
        <th *ngSwitchCase="2" pSortableColumn="DOCITEMSUM" pResizableColumn style="width: 10rem !important">Сумма <p-sortIcon field="DOCITEMSUM"></p-sortIcon></th>
        <th *ngSwitchCase="4" pSortableColumn="DOCITEMPRICE" pResizableColumn style="width: 8rem !important">Цена <p-sortIcon field="DOCITEMPRICE"></p-sortIcon></th>
        <th *ngSwitchCase="4" pSortableColumn="DOCITEMSUM" pResizableColumn style="width: 10rem !important">Сумма <p-sortIcon field="DOCITEMSUM"></p-sortIcon></th>
        <th *ngSwitchCase="5" pSortableColumn="DOCITEMPRICE" pResizableColumn style="width: 8rem !important">Цена <p-sortIcon field="DOCITEMPRICE"></p-sortIcon></th>
        <th *ngSwitchCase="5" pSortableColumn="DOCITEMSUM" pResizableColumn style="width: 10rem !important">Сумма <p-sortIcon field="DOCITEMSUM"></p-sortIcon></th>
        <th *ngSwitchCase="12" pSortableColumn="DOCITEMPRICE" pResizableColumn style="width: 8rem !important">Цена <p-sortIcon field="DOCITEMPRICE"></p-sortIcon></th>
        <th *ngSwitchCase="12" pSortableColumn="DOCITEMSUM" pResizableColumn style="width: 10rem !important">Сумма <p-sortIcon field="DOCITEMSUM"></p-sortIcon></th>
        <th *ngSwitchCase="7" pSortableColumn="DOCITEMTEXT1" pResizableColumn style="width: 12rem !important">Серийный номер <p-sortIcon field="DOCITEMTEXT1"></p-sortIcon></th>
        <th *ngSwitchCase="7" pSortableColumn="DOCITEMTEXT2" pResizableColumn style="width: 12rem !important">Гарантия<p-sortIcon field="DOCITEMTEXT2"></p-sortIcon></th>
        <th *ngSwitchDefault pSortableColumn="DOCITEMPRICE" pResizableColumn style="width: 8rem !important">Цена <p-sortIcon field="DOCITEMPRICE"></p-sortIcon></th>
        <th *ngSwitchDefault pSortableColumn="DOCITEMSUM" pResizableColumn style="width: 10rem !important">Сумма <p-sortIcon field="DOCITEMSUM"></p-sortIcon></th>
      </tr>
      <tr [ngSwitch]="selectedDocType" *ngIf="selectedDocContent.length > 5">
        <th style="width: 3rem"></th>
        <th style="width: 25% !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'PRODCODE', 'contains')"
                 placeholder="Поиск" [(ngModel)]="cf['PRODCODE']" class="p-column-filter" [class.hasvalue]="cf['PRODCODE']">
        </th>
        <th style="width: 35% !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMPRODNAME', 'contains')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMPRODNAME']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMPRODNAME']">
        </th>
        <th *ngSwitchCase="1" style="width: 6rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMPRODNAME', 'contains')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMPRODNAME']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMPRODNAME']">
        </th>

        <th *ngSwitchCase="2" style="width: 6rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMSTOCK', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMSTOCK']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMSTOCK']">
        </th>
        <th *ngSwitchCase="4" style="width: 6rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMSTOCK', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMSTOCK']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMSTOCK']">
        </th>
        <th *ngSwitchCase="5" style="width: 6rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMSTOCK', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMSTOCK']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMSTOCK']">
        </th>
        <th *ngSwitchCase="12" style="width: 6rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMSTOCK', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMSTOCK']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMSTOCK']">
        </th>
        <th style="width: 8rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMQTY', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMQTY']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMQTY']">
        </th>
        <th *ngSwitchCase="1" style="width: 6rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMSHIPPED', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMSHIPPED']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMSHIPPED']">
        </th>
        <th *ngSwitchCase="1" style="width: 8rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMPRICE', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMPRICE']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMPRICE']">
        </th>
        <th *ngSwitchCase="1" style="width: 10rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMSUM', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMSUM']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMSUM']">
        </th>
        <th *ngSwitchCase="2" style="width: 8rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMPRICE', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMPRICE']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMPRICE']">
        </th>
        <th *ngSwitchCase="2" style="width: 10rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMSUM', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMSUM']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMSUM']">
        </th>
        <th *ngSwitchCase="4" style="width: 8rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMPRICE', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMPRICE']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMPRICE']">
        </th>
        <th *ngSwitchCase="4" style="width: 10rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMSUM', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMSUM']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMSUM']">
        </th>
        <th *ngSwitchCase="5" style="width: 8rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMPRICE', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMPRICE']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMPRICE']">
        </th>
        <th *ngSwitchCase="5" style="width: 10rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMSUM', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMSUM']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMSUM']">
        </th>
        <th *ngSwitchCase="12" style="width: 8rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMPRICE', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMPRICE']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMPRICE']">
        </th>
        <th *ngSwitchCase="12" style="width: 10rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMSUM', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMSUM']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMSUM']">
        </th>
        <th *ngSwitchCase="7" style="width: 12rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMTEXT1', 'contains')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMTEXT1']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMTEXT1']">
        </th>
        <th *ngSwitchCase="7" style="width: 12rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMTEXT2', 'contains')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMTEXT2']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMTEXT2']">
        </th>
        <th *ngSwitchDefault style="width: 8rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMPRICE', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMPRICE']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMPRICE']">
        </th>
        <th *ngSwitchDefault style="width: 10rem !important">
          <input pInputText type="text" (input)="cTable.filter($event.target.value, 'DOCITEMSUM', 'GteOrZero')"
                 placeholder="Поиск" [(ngModel)]="cf['DOCITEMSUM']" class="p-column-filter" [class.hasvalue]="cf['DOCITEMSUM']">
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-sdcontent let-expanded="expanded">
      <tr [ngSwitch]="selectedDocType" [pSelectableRow]="sdcontent">
        <td style="width: 3rem">
          <button type="button" pButton pRipple pTooltip="Информация о резервировании"
                  [pRowToggler]="sdcontent" class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
          </button>
        </td>
        <td>
          <a [routerLink]="['/edit-product', sdcontent.PRODID]">{{sdcontent.PRODCODE}}</a>
        </td>
        <td>{{sdcontent.DOCITEMPRODNAME}}</td>

        <td *ngSwitchCase="1" style="text-align: right">
          <span *ngIf="sdcontent.prodInfo as pi" [class.darkgreen]="(pi.PRODSTOCK > 0)">
            {{pi.PRODSTOCK | number:'1.0-2' }}
          </span>
        </td>
        <td *ngSwitchCase="2" style="text-align: right">
          <span *ngIf="sdcontent.prodInfo as pi" [class.darkgreen]="(pi.PRODSTOCK > 0)">
            {{pi.PRODSTOCK | number:'1.0-2' }}
          </span>
        </td>
        <td *ngSwitchCase="4" style="text-align: right">
          <span *ngIf="sdcontent.prodInfo as pi" [class.darkgreen]="(pi.PRODSTOCK > 0)">
            {{pi.PRODSTOCK | number:'1.0-2' }}
          </span>
        </td>
        <td *ngSwitchCase="5" style="text-align: right">
          <span *ngIf="sdcontent.prodInfo as pi" [class.darkgreen]="(pi.PRODSTOCK > 0)">
            {{pi.PRODSTOCK | number:'1.0-2' }}
          </span>
        </td>
        <td *ngSwitchCase="12" style="text-align: right">
          <span *ngIf="sdcontent.prodInfo as pi" [class.darkgreen]="(pi.PRODSTOCK > 0)">
            {{pi.PRODSTOCK | number:'1.0-2' }}
          </span>
        </td>
        <td style="text-align: right" [class.redst]="sdcontent.LST" [class.darkgreen]="sdcontent.FSH" [class.yellowst]="sdcontent.RDY">{{sdcontent.DOCITEMQTY | number:'1.0-2' }}</td>

        <td *ngSwitchCase="1" style="text-align: right">{{sdcontent.DOCITEMSHIPPED | number:'1.0-2' }}</td>
        <td *ngSwitchCase="1" style="text-align: right">{{sdcontent.DOCITEMPRICE | number:'1.2-2' }}</td>
        <td *ngSwitchCase="1" style="text-align: right">{{sdcontent.DOCITEMSUM | number:'1.2-2' }}</td>
        <td *ngSwitchCase="2" style="text-align: right">{{sdcontent.DOCITEMPRICE | number:'1.2-2' }}</td>
        <td *ngSwitchCase="2" style="text-align: right">{{sdcontent.DOCITEMSUM | number:'1.2-2' }}</td>
        <td *ngSwitchCase="4" style="text-align: right">{{sdcontent.DOCITEMPRICE | number:'1.2-2' }}</td>
        <td *ngSwitchCase="4" style="text-align: right">{{sdcontent.DOCITEMSUM | number:'1.2-2' }}</td>
        <td *ngSwitchCase="5" style="text-align: right">{{sdcontent.DOCITEMPRICE | number:'1.2-2' }}</td>
        <td *ngSwitchCase="5" style="text-align: right">{{sdcontent.DOCITEMSUM | number:'1.2-2' }}</td>
        <td *ngSwitchCase="7">{{sdcontent.DOCITEMTEXT1}}</td>
        <td *ngSwitchCase="7">{{sdcontent.DOCITEMTEXT2}}</td>
        <td *ngSwitchCase="12" style="text-align: right">{{sdcontent.DOCITEMPRICE | number:'1.2-2' }}</td>
        <td *ngSwitchCase="12" style="text-align: right">{{sdcontent.DOCITEMSUM | number:'1.2-2' }}</td>
        <td *ngSwitchDefault style="text-align: right">{{sdcontent.DOCITEMPRICE | number:'1.2-2' }}</td>
        <td *ngSwitchDefault style="text-align: right">{{sdcontent.DOCITEMSUM | number:'1.2-2' }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer" *ngIf="showFooterTotal">
      <tr [ngSwitch]="selectedDocType">
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>

        <td>&nbsp;</td>
        <td *ngSwitchCase="1" style="text-align: right">{{totalInvoiceItems | number:'1.0-0' }}</td>
        <td *ngSwitchCase="2" style="text-align: right">{{totalInvoiceItems | number:'1.0-0' }}</td>
        <td *ngSwitchCase="4" style="text-align: right">{{totalInvoiceItems | number:'1.0-0' }}</td>
        <td *ngSwitchCase="5" style="text-align: right">{{totalInvoiceItems | number:'1.0-0' }}</td>
        <td *ngSwitchCase="7" style="text-align: right">{{totalInvoiceItems | number:'1.0-0' }}</td>
        <td *ngSwitchCase="12">&nbsp;</td>

        <td *ngSwitchCase="1">&nbsp;</td>
        <td *ngSwitchCase="1">&nbsp;</td>
        <td *ngSwitchCase="1" style="text-align: right">{{totalInvoiceSum | number:'1.2-2' }}</td>
        <td *ngSwitchCase="2">&nbsp;</td>
        <td *ngSwitchCase="2" style="text-align: right">{{totalInvoiceSum | number:'1.2-2' }}</td>
        <td *ngSwitchCase="4">&nbsp;</td>
        <td *ngSwitchCase="4" style="text-align: right">{{totalInvoiceSum | number:'1.2-2' }}</td>
        <td *ngSwitchCase="5">&nbsp;</td>
        <td *ngSwitchCase="5" style="text-align: right">{{totalInvoiceSum | number:'1.2-2' }}</td>
        <td *ngSwitchCase="7">&nbsp;</td>
        <td *ngSwitchCase="7" style="text-align: right">{{totalInvoiceSum | number:'1.2-2' }}</td>
        <td *ngSwitchCase="12">&nbsp;</td>
        <td *ngSwitchCase="12">&nbsp;</td>
        <td *ngSwitchDefault style="text-align: right">&nbsp;</td>
        <td *ngSwitchDefault style="text-align: right">{{totalInvoiceSum | number:'1.2-2' }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-prod>
      <tr>
        <td colspan="8" *ngIf="selectedDocType == 1">
          <app-product-reservation-table [prodId]="prod.PRODID"></app-product-reservation-table>
        </td>
        <td colspan="7" *ngIf="[2,3,4,5,10,12].includes(selectedDocType)">
          <app-product-reservation-table [prodId]="prod.PRODID"></app-product-reservation-table>
        </td>
        <td colspan="6" *ngIf="[6,7,8,9,11,13,14].includes(selectedDocType)">
          <app-product-reservation-table [prodId]="prod.PRODID"></app-product-reservation-table>
        </td>
      </tr>
    </ng-template>

    <!--<ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6">Пустой документ</td>
      </tr>
    </ng-template>-->
  </p-table>
</div>
